import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';

export interface IMeta {
  language: string;
  title: string;
  description?: string;
  keywords?: string;
  ogUrl?: string;
  ogType?: string;
  ogImage?: string;
  ogImageSecureUrl?: string;
}

@Injectable({
  providedIn: 'root',
})
export class MetaService {
  metas: any = {
    es: {
      home: 'Inviertis: Inversión inmobiliaria rentable',
      home_desc:
        'Invierte en un piso alquilado con información verificada y análisis financieros. Inviertis, rentabilidad inmediata.',
      about: 'Equipo Inviertis - Expertos en inversiones inmobiliarias',
      about_desc:
        'Expertos en inversiones inmobiliarias itermedian en Inviertis para hacer posible la compra-venta online de inmuebles alquilados.',
      como_funciona: 'Paso a paso para invertir en Inmuebles alquilados',
      como_funciona_desc:
        'Puedes invertir en inmuebles alquilados con confianza: analizamos los activos inmobiliarios antes de publicarlos. Proceso 100% online y sin visitas',
      contacto: 'Contacta con Inviertis - Especialistas en inversión rentable',
      contacto_desc:
        'Déjanos tus datos con el mensaje que nos quieras transmitir y un agente especializado en inversión rentable se pondrá en contacto contigo',
      politica: 'Política de Privacidad INVIERTIS',
      politica_desc:
        'Política de privacidad Inviertis - Vende e invierte seguro en propiedades con inquilinos. Protección de datos, datos recabados, finalidad y licitud.',
      cookies: 'Políticas de Cookies',
      cookies_desc:
        'Políticas de Cookies - Vende e invierte seguro en propiedades con inquilinos',
      aviso_legal: 'Inviertis - Aviso Legal',
      aviso_legal_desc:
        'Aviso Legal Inviertis - Vende e invierte en propiedades con inquilinos. Datos identificativos, protección de datos, propiedad intelectual y más.',
      calculadora:
        'Descárgate gratis nuestra Calculadora de rentabilidad-Inviertis',
      calculadora_desc:
        '¡Consigue la calculadora de rentabilidad inmobiliaria de Inviertis y decídete a sacar partido de tu inmueble en alquiler!',
      login: 'Conéctate a Inviertis',
      login_desc:
        'Conecta con la comunidad de Inviertis - Vende e invierte de forma segura en propiedades con inquilinos. Inviertis, rentabilidad inmediata.',
      recover_pass: 'Recuperar Contraseña Inviertis',
      recover_pass_desc:
        'Mándanos tu mail para recuperar tu contraseña de Inviertis',
      recover_pass_hash: 'Recuperar Contraseña',
      compact_wizzard:
        'Venta de pisos alquilados totalmente online sin visitas',
      compact_wizzard_desc:
        'Vende online tu piso alquilado en nuestra plataforma, sin costes de fricción, ni mejoras en el inmueble. Más de 8.000 inversores esperan pisos como el tuyo.',
      services: 'Servicios adicionales inmueble en rentabilidad',
      services_desc:
        'Valoramos cada inmueble en rentabilidad como un activo inmobiliario. Seguro de impago preconcedido y facilidades de financiación para inversores',
      gestion_alquiler:
        'Gestión de alquiler integral al mejor precio - Inviertis',
      gestion_alquiler_desc:
        'Nos encargamos de todo con nuestro servicio gestión de alquiler integral. Tu tranquilidad por muy poco',
      seguros: 'Seguros para asegurar tu inversión inmobiliaria - Inviertis',
      seguros_desc:
        'Asegura tu inversión, protégete de impagos y vive tranquilamente con nuestros seguros seleccionados para inmuebles de inversión',
      seguro_impago:
        'Seguros de impago del alquiler con las mejores coberturas - Inviertis',
      seguro_impago_desc:
        'Contrata el seguro de impago al alquiler directamente con Inviertis y benefíciate de todas nuestras bonificaciones al mejor precio.',
      hipotecas:
        'Te ayudamos a conseguir la hipoteca que necesitas - Inviertis',
      hipotecas_desc:
        'Nuestros brokers inmobiliarios negociarán la mejor hipoteca para ti. Elige tu hipoteca fija o variable entre más de 20 bancos.',
      seguro_mapfre:
        'Seguros de Hogar, tu inversión siempre cubierta - Inviertis',
      seguro_mapfre_desc:
        'Porque no todas tus propiedades son iguales, tenemos un seguro para cada uno. Benefíciate de todas nuestras bonificaciones  con el mejor precio.',
      valoracion: 'Te valoramos tu vivienda gratuitamente - Inviertis',
      valoracion_desc:
        'Te valoramos tu piso alquilado de forma gratuita para que puedas venderlo con éxito. Analizamos el mercado inmobiliario por ti.',
      certificado_energetico:
        'Tu certificado energético en tres sencillos pasos - Inviertis',
      certificado_energetico_desc:
        'Contrata ahora el servicio de certificado energético de Inviertis de la mano de los mejores profesionales al mejor precio, ahorrando tiempo y dinero.',
      registro: 'Regístrate en Inviertis',
      registro_desc:
        'Regístrate y forma parte de la comunidad Inviertis - Vende e invierte en propiedades con inquilinos.',
      terminos: 'Términos y condiciones de uso de Inviertis',
      terminos_desc:
        'Términos y condiciones de uso generales aplicables a los servicios ofrecidos por Inviertis - Vende e invierte en propiedades con inquilinos',
      area_profile: 'Dashboard Usuario',
      area_profile_desc: 'Dashboard Usuario - Inviertis',
      twitter:
        'Inviertis: Inversión inmobiliaria rentable: Propiedades con inquilinos',
      twitter_desc: 'Vende e invierte en propiedades con inquilinos',
    },
    en: {
      home: 'Inviertis: Profitable real estate investment',
      home_desc:
        'Invest in a rented apartment with verified information and financial analysis. Inviertis, immediate profitability.',
      about: 'Inviertis Team - Experts in real estate investments',
      about_desc:
        'Experts in real estate investments itermedian in Inviertis to make possible the online purchase and sale of rented properties.',
      como_funciona: 'Step by step to invest in rented properties',
      como_funciona_desc:
        'You can invest in rented properties with confidence: we analyze real estate assets before publishing them. Process 100% online and without visits',
      contacto: 'Contact Inviertis - Specialists in profitable investment',
      contacto_desc:
        'Leave us your information with the message you want to send us and an agent specializing in profitable investment will contact you',
      politica: 'INVIERTIS PRIVACY POLICY',
      politica_desc:
        'Privacy Policy of Inviertis - Sell and invest safely in properties with tenants. Data protection officer, policy, data collected, purposes and legality.',
      cookies: 'Cookie Policies',
      cookies_desc:
        'Cookies Policy of Inviertis - Sell and invest safely in properties with tenants in Inviertis. Explanation and cookie consent.',
      aviso_legal: 'Inviertis - Legal Notice',
      aviso_legal_desc:
        'Legal Notice Inviertis - Sell and invest safely in properties with tenants. Identifying data, data protection, intellectual property and more.',
      calculadora: 'Download our Profitability calculator for free - Inviertis',
      calculadora_desc:
        'Get the Inviertis real estate profitability calculator and decide to take advantage of your property for rent!',
      login: 'Connect to Inviertis',
      login_desc:
        'Connect to the Inviertis community - Sell and invest safely in properties with tenants. Inviertis, immediate profitability.',
      recover_pass: 'Recover your Inviertis password',
      recover_pass_desc:
        'Have you forgotten your password? Send us your email to recover your Inviertis password. We will send you and email after.',
      recover_pass_hash: 'ecover Password',
      compact_wizzard:
        'Sale of rented apartments totally online without visits',
      compact_wizzard_desc:
        'Sell ​​your rented apartment online on our platform, without friction costs. More than 8,000 investors are waiting for apartments with a tenant like yours.',
      services: 'Additional services property in profitability',
      services_desc:
        'We value each property in profitability as a real estate asset. Pre-approved default insurance and financing facilities for investors',
      gestion_alquiler:
        'Comprehensive rental management at the best price - Inviertis',
      gestion_alquiler_desc:
        'We take care of everything with our comprehensive rental management service. Your peace of mind for very little',
      seguros: 'Insurance to insure your real estate investment - Inviertis',
      seguros_desc:
        'Insure your investment, protect yourself from non-payment and live peacefully with our selected insurance for investment properties',
      seguro_impago:
        'Non-payment of rent insurance with the best coverage - Inviertis',
      seguro_impago_desc:
        'Take out rental non-payment insurance directly with Inviertis and benefit from all our discounts at the best price.',
      hipotecas: 'We help you get the mortgage you need - Inviertis',
      hipotecas_desc:
        'Our real estate brokers will negotiate the best mortgage for you. Choose your fixed or variable mortgage from more than 20 banks.',
      seguro_mapfre:
        'Home Insurance, your investment always covered - Inviertis',
      seguro_mapfre_desc:
        'Because not all your properties are the same, we have insurance for each one. Take advantage of all our bonuses with the best price.',
      valoracion: 'We value your home for free - Inviertis',
      valoracion_desc:
        'We value your rented property for free so that you can sell it successfully. We analyze the real estate market for you.',
      certificado_energetico:
        'Your energy certificate in three easy steps - Inviertis',
      certificado_energetico_desc:
        'Hire now the Inviertis energy certificate service from the best professionals at the best price, saving time and money.',
      registro: 'Register in Inviertis',
      registro_desc:
        'Register and be part of the Inviertis community - Sell and invest safely in properties with tenants. Inviertis, immediate profitability.',
      terminos: 'Terms and conditions of use of Inviertis',
      terminos_desc:
        'General terms and conditions of use applicable to the services offered by Inviertis - Sell and invest safely in properties with tenants',
      area_profile: 'Dashboard User',
      area_profile_desc: 'Dashboard User - Inviertis',
      twitter:
        'Inviertis: Profitable real estate investment: Properties with tenants',
      twitter_desc: 'Sell ​​and invest in properties with tenants',
    },
  };
  constructor(
    private titleService: Title,
    private metaService: Meta,
    @Inject(PLATFORM_ID) private platformId: string
  ) {}

  public changeMeta(metaObject: IMeta) {
    this.titleService.setTitle(
      this.metas[metaObject.language][metaObject.title] ?? metaObject.title
    );
    if (isPlatformBrowser(this.platformId)) {
      this.metaService.updateTag({
        property: 'og:url',
        content: metaObject.ogUrl ?? location.href,
      });
    }
    this.metaService.updateTag({
      property: 'og:type',
      content: metaObject.ogType ?? 'Website',
    });
    this.metaService.updateTag({
      name: 'title',
      content:
        this.metas[metaObject.language][metaObject.title] ?? metaObject.title,
    });
    if (metaObject.description) {
      this.metaService.updateTag({
        name: 'description',
        content:
          this.metas[metaObject.language][metaObject.description] ??
          metaObject.description,
      });
    }
    if (metaObject.keywords) {
      this.metaService.updateTag({
        name: 'keywords',
        content: metaObject.keywords,
      });
    }
    if (metaObject.ogImage) {
      this.metaService.updateTag({
        name: 'og:image',
        content: metaObject.ogImage,
      });
    }
    if (metaObject.ogImageSecureUrl) {
      this.metaService.updateTag({
        name: 'og:image:secure_url',
        content: metaObject.ogImageSecureUrl,
      });
    }
    this.metaService.updateTag({
      property: 'twitter:title',
      content: this.metas[metaObject.language].twitter,
    });
    this.metaService.updateTag({
      property: 'twitter:description',
      content: this.metas[metaObject.language].twitter_desc,
    });
  }
}
